import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';

import { UserSettingsEntityActions } from '../../store/user-settings-entity/user-settings-entity.actions';
import { Router } from '@angular/router';
import { FormGroup, UntypedFormGroup } from '@angular/forms';
import { UserSettingsActions } from '../../store/user-settings/user-settings.actions';
import type { UserSettings } from 'src/app/core/models/user-settings.model';
import { Observable } from 'rxjs';
import { selectUserSettings } from '../../store/user-settings/user-settings.selectors';
import { LoadingActions } from 'src/app/core/store/loading/loading.actions';
import type { Entity } from '../../../core/models/entity.model';
import type { EntityEditorPropertyChangedEvent } from '../../../entity-editor/models/entity-editor-property-changed.event';

@Component({
  selector: 'app-user-settings-form',
  templateUrl: './user-settings-form.component.html',
  styleUrls: ['./user-settings-form.component.scss'],
  standalone: false
})
export class UserSettingsFormComponent implements OnInit {
  @Input() userSettingsEntity: Entity;

  @Output() submitForm = new EventEmitter<void>();

  @Input() messages: Entity[];

  userSettings$: Observable<UserSettings>;

  protected userSettingsForm: UntypedFormGroup;

  constructor(private store: Store, private router: Router) {
    this.userSettings$ = this.store.select(selectUserSettings);
  }

  ngOnInit(): void {
    this.userSettingsForm = new FormGroup({});
  }

  propertyChange(event: EntityEditorPropertyChangedEvent) {
    const settings = { ...this.userSettingsForm.value, [event.propertyKey]: event.value };
    this.store.dispatch(UserSettingsEntityActions.update_entity_start({ settings }));
  }

  onSave() {
    this.userSettingsForm.updateValueAndValidity({ emitEvent: false });
    if (this.userSettingsForm.valid) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { SaveButton, LinkToHomepage, ...updatedSettings } = this.userSettingsForm.value;

      const settings: UserSettings = {};
      for (const updatedSettingsKey in this.userSettingsEntity.Properties) {
        settings[updatedSettingsKey] = this.userSettingsEntity.Properties[updatedSettingsKey].Value;
      }

      const userSettings = {
        ...settings,
        ...updatedSettings
      };

      this.store.dispatch(UserSettingsActions.set_user_settings_start({ userSettings }));
    } else {
      this.store.dispatch(LoadingActions.loading_end());
      this.userSettingsForm.markAllAsTouched();
    }
  }

  onNavigateToHomepage() {
    this.router.navigate(['/projects']);
  }
}
